import React, { Component } from "react";
// import MainProfile from './MainProfile.jsx';
import InitialMainProfile from "./InitialMainProfile.jsx";
import { withStyles } from "@material-ui/core/styles";
import { compose } from "redux";
import { Button, Radio, TextField, Typography } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import LogoutAlert from "../../components/Alert/LogoutAlert.jsx";
import UpdateProfile from "./UpdateProfile.jsx";
import * as actions from '../../actions/index.js';
import { FormattedMessage, injectIntl } from "react-intl";
import { ROLE_CUSTOMER, ROLE_PROVIDER } from "../../utils/config/constants.js";
import { withRouter } from "react-router-dom";
import { AccountBalanceWallet, SearchIcon } from "@material-ui/icons";
import { connect } from "react-redux";
import { Clear, Add, Remove, ArrowLeft, ArrowRight, ArrowForward, ArrowBack, Category,ArrowRightAltOutlined  } from '@material-ui/icons';
import ContentLoader from "react-content-loader";
import { Box, FormControl, FormControlLabel, FormLabel, RadioGroup } from "@mui/material";
import Dropzone from "react-dropzone";
import uploadIcon from '../../assets/img/profile-upload-icon.png'
import { NotificationManager } from "react-notifications";
import NavbarNew from "../../components/NavBarNew/NavbarNew.js";

let isMounted = false;


const styles = (theme) => ({
    card: {
        color: theme.palette.secondary.main,
    },
});
const sendProps = (props) => {
    const { classes, ...rest } = props;
    return rest;
};
class ViewAdditionalInfoScreenNew extends Component {
    constructor(props) {
        super(props);

        console.log("View data", props)

        this.state = { 
            update: false, 
            showAlert: false,
            // home_aval: false
            home_aval: 1,
            home_instruction: '',
            home_stay: '',
            img_url_1:'',
            img_url_2:'',
            img_url_3:'',
            img_url_4:'',
            bookingDetailsPrev: this.props.history.location.state.bookingDetails,
            // bookingInfoDataPrev : this.props.history.location.state.bookingInfoData,
        };

    }
    componentDidMount() {
        // console.log("ADDITONAL INFO taskDetailsPrev DETSSSSSSSS---", this.state.taskDetailsPrev);
        console.log("this.state.bookingDetailsPrev---", this.state.bookingDetailsPrev);
    }

    componentWillUnmount() {
    }

    renderLoading = index => {
        return (
            <div style={{ width: 250, margin: 10, height: 250 }} key={index}>
                <ContentLoader
                    height={200}
                    width={200}
                    speed={2}
                    borderRadius={5}
                    primaryColor="#f3f3f3"
                    secondaryColor="#ecebeb"
                >
                    <rect x="0" y="0" rx="0" ry="0" width="200" height="160" />
                    <rect
                        x="100"
                        y="100"
                        rx="0"
                        ry="0"
                        width="200"
                        height="10"
                    />
                </ContentLoader>
            </div>
        );
    };

    render() {


        var well={
            boxShadow: "2px 1px 5px #ddd",
            backgroundColor: '#fff',
            padding: 10,
            marginBottom: 20,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            // textAlign: 'center',
            cursor: 'pointer',
            borderRadius: 5
        }
        return (
            <div className="tz-2-com tz-2-main h4-padding">
                <div style={{ paddingBottom: "25px" }} className="db-list-com">
                    <div className="row">
                        <div className="col-md-12">
                            <NavbarNew
                                title='View Additional Info' 
                                goback={() => this.props.history.goBack(null)} 
                            />
                            <div>
                                <div >
                                    <p>Will be Home - {this.state.bookingDetailsPrev.home_stay == 2 ? 'No' : 'Yes'}</p>
                                    {
                                        this.state.bookingDetailsPrev.home_stay == 2
                                        ? <p>Note - {this.state.bookingDetailsPrev.home_instruction}</p>
                                        : null
                                    }
                                </div>
                                <div>
                                    <p>Notes / Instructions</p>
                                    <p>{this.state.bookingDetailsPrev.instructions}</p>
                                </div>
                                <div>
                                    <p>Uploaded Photos</p>
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'space-around',
                                        alignItems: 'center',
                                        border: '1px solid #eee',
                                        borderRadius: '10px',
                                        padding: '20px 20px 0 20px'
                                    }}> 
                                        <div style={{
                                        display: 'flex',
                                        justifyContent: 'space-evenly',
                                        width: '100%',
                                        alignItems: 'center',
                                        marginBottom: 20
                                        }}>
                                            {
                                                this.state.bookingDetailsPrev.booking_img1 
                                                ?
                                                    <img 
                                                        src={this.state.bookingDetailsPrev.booking_img1}
                                                        style={{ height: '15rem', width: '15rem', borderRadius: 10 }} 
                                                    />
                                                : 
                                                    <div style={{
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                        height: '15rem', 
                                                        width: '15rem', 
                                                        borderRadius: 10,
                                                        backgroundColor: '#ddd'
                                                    }}>
                                                        <p>No Photo Added</p>
                                                    </div>
                                            }
                                            {
                                                this.state.bookingDetailsPrev.booking_img2
                                                ?
                                                    <img 
                                                        src={this.state.bookingDetailsPrev.booking_img2}
                                                        style={{ height: '15rem', width: '15rem', borderRadius: 10 }} 
                                                    /> 
                                                : 
                                                    <div style={{
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                        height: '15rem', 
                                                        width: '15rem', 
                                                        borderRadius: 10,
                                                        backgroundColor: '#ddd'
                                                    }}>
                                                        <p>No Photo Added</p>
                                                    </div>
                                            }
                                        </div>
                                        <div  style={{
                                            display: 'flex',
                                            justifyContent: 'space-evenly',
                                            width: '100%',
                                            alignItems: 'center',
                                            marginBottom: 20
                                        }}> 
                                            {
                                                this.state.bookingDetailsPrev.booking_img3
                                                ?
                                                    <img 
                                                        src={this.state.bookingDetailsPrev.booking_img3}
                                                        style={{ height: '15rem', width: '15rem', borderRadius: 10 }} 
                                                    /> 
                                                : 
                                                    <div style={{
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                        height: '15rem', 
                                                        width: '15rem', 
                                                        borderRadius: 10,
                                                        backgroundColor: '#ddd'
                                                    }}>
                                                        <p>No Photo Added</p>
                                                    </div>
                                            }
                                            {
                                                this.state.bookingDetailsPrev.booking_img4
                                                ?
                                                    <img 
                                                        src={this.state.bookingDetailsPrev.booking_img4}
                                                        style={{ height: '15rem', width: '15rem', borderRadius: 10 }} 
                                                    /> 
                                                : 
                                                    <div style={{
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                        height: '15rem', 
                                                        width: '15rem', 
                                                        borderRadius: 10,
                                                        backgroundColor: '#ddd'
                                                    }}>
                                                        <p>No Photo Added</p>
                                                    </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div style={{
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    marginTop: 20
                                }}>
                                    <p 
                                    onClick={this.onContinuePressed}
                                    style={{
                                        backgroundColor: '#0078ff',
                                        padding: 10,
                                        color: '#fff',
                                        borderRadius: 5,
                                        fontSize: 16,
                                        textAlign: 'center'
                                    }}>Okay <ArrowRightAltOutlined /></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ settings, categories, providers, auth }) => {
    return {
        settings,
        categoryData: categories.categoryData,
        featuredProviderList: providers.featuredProviderList,
        featuredProviderLoader: providers.featuredProviderLoader,
        userData: auth.userData,

    };
};
const composedProfile = compose(connect(mapStateToProps, actions));
export default composedProfile(withRouter(ViewAdditionalInfoScreenNew));



// WEBPACK FOOTER //
// ./src/views/User/ViewAdditionalInfoScreenNew.jsx